import Vue from 'vue';
import moment from 'moment-timezone';

moment.tz.setDefault('Europe/Copenhagen');

Vue.use(require('vue-moment'), {
  moment,
});



// WEBPACK FOOTER //
// ./src/plugins/options/vueMoment.js